import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Testimonials from "./pages/Testimonials";
import PropertyDetail from "./pages/PropertyDetail";
import Landlords from "./pages/Landlords";
import TermsSign from "./pages/TermsSign";
import TermsLinksAdmin from "./pages/TermsLinksAdmin";
import TermsBankDetails from "./pages/TermsBankDetails";
import AreaGuide from "./pages/AreaGuide";
import AreasIndex from "./pages/AreasIndex";
import LicensingGuide from "./pages/LicensingGuide";
import MyNewSpace from "./pages/MyNewSpace";
import MakeAnOffer from "./pages/MakeAnOffer";
import MoveOut from "./pages/MoveOut";
import Valuation from "./pages/Valuation";
import ValuationInPerson from "./pages/ValuationInPerson";
import ValuationVirtual from "./pages/ValuationVirtual";
import ValuationInstant from "./pages/ValuationInstant";
// eslint-disable-next-line no-unused-vars
import CheckOut from "./pages/CheckOut";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/property/:id" element={<PropertyDetail />} />
        <Route path="/landlords" element={<Landlords />} />
        <Route path="/mynewspace" element={<MyNewSpace />} />
        <Route path="/make-an-offer" element={<MakeAnOffer />} />
        <Route path="/valuation" element={<Valuation />} />
        <Route path="/valuation/in-person" element={<ValuationInPerson />} />
        <Route path="/valuation/virtual" element={<ValuationVirtual />} />
        <Route path="/valuation/instant" element={<ValuationInstant />} />
        <Route path="/move-out" element={<MoveOut />} />
        <Route path="/check-out" element={<MoveOut />} />
        <Route path="/landlords/terms" element={<TermsSign />} />
        <Route path="/landlords/terms/admin" element={<TermsLinksAdmin />} />
        <Route path="/landlords/terms/bank/:id" element={<TermsBankDetails />} />
        <Route path="/landlords/terms/:code" element={<TermsSign />} />
        <Route path="/areas" element={<AreasIndex />} />
        <Route path="/areas/:slug" element={<AreaGuide />} />
        <Route path="/landlords/hmo-licensing-hackney" element={<LicensingGuide />} />
        <Route path="/guides/hackney-hmo-licensing" element={<LicensingGuide />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
